import { directives } from "../utils/alpine";
import activate from "./activate";
import contentLocation from "./contentLocation";
import contentScrollTop from "./contentScrollTop";
import contentRange from "./contentRange";
import contextMenuActivate from "./contextMenuActivate";
import contentLinkHover from "./contentLinkHover";
import dialog from "./dialog";
import keydown from "./keydown";
import overflow from "./overflow";
import shortcut from "./shortcut";
import split from "./split";
import tippyDropdown from "./tippyDropdown";
import tooltip from "./tooltip";

directives({
  activate: activate,
  "content-location": contentLocation,
  "content-scroll-top": contentScrollTop,
  "content-range": contentRange,
  "context-menu-activate": contextMenuActivate,
  "content-link-hover": contentLinkHover,
  dialog,
  keydown,
  overflow: overflow,
  split,
  shortcut,
  "tippy-dropdown": tippyDropdown,
  tooltip: tooltip,
});
